function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M17,4a1,1,0,0,1,1,1V19a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V1A1,1,0,0,1,3,0H7A1,1,0,0,1,7,2H4V18H16V5A1,1,0,0,1,17,4ZM8,11V5a1,1,0,0,1,2,0v6a.915.915,0,0,0,1,1,.919.919,0,0,0,1-1.012V3a.915.915,0,0,0-1-1,1,1,0,1,1,0-2,2.916,2.916,0,0,1,3,3v8a2.916,2.916,0,0,1-3,3A2.916,2.916,0,0,1,8,11Z",
  transform: "translate(-2)",
  fill: "#949db2"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/download-order.c91d8023.svg";
export { SvgComponent as ReactComponent };